module.exports = __webpack_public_path__ + "static/media/vodafoneziggo.e8fabb9c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/vodafoneziggo.webp
// module id = 792
// module chunks = 0